module.exports = __webpack_public_path__ + "img/p7.bd529dc8.png";